import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
  name: 'gbDateRange',
})
export class GbDateRangePipe implements PipeTransform {
  constructor() {}

  transform(dates: string[], timezone: string): string {
    const startDate = new Date(dates[0])
    const endDate = new Date(dates[1])

    const startDateString = this.getFormattedDateString(startDate, timezone)
    const endDateString = this.getFormattedDateString(endDate, timezone)

    if (this.isDatesSame(startDate, endDate)) {
      // if dates same, format with time range i.e. Tue, January 9, 2024 5:00 PM - 10:00 PM
      const endTimeString = endDateString.substring(
        endDateString.lastIndexOf(' ', endDateString.lastIndexOf(' ') - 1) + 1,
      )
      return `${startDateString} - ${endTimeString}`
    } else {
      // if dates different, format with both dates and times
      // i.e. Tue, January 9, 2024 5:00 PM - Wed, January 10, 2024 10:00 PM
      return `${startDateString} - ${endDateString}`
    }
  }

  isDatesSame(startDate: Date, endDate: Date): boolean {
    return (
      startDate.getUTCFullYear() === endDate.getUTCFullYear() &&
      startDate.getUTCMonth() === endDate.getUTCMonth() &&
      startDate.getUTCDate() === endDate.getUTCDate()
    )
  }

  getFormattedDateString(date: Date, timezone: string): string {
    const options: Intl.DateTimeFormatOptions = {
      weekday: 'short',
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      timeZone: timezone,
    }
    return date.toLocaleString('en-US', options).replace(' at ', ' ')
  }
}
